import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

/**
 * Auth state - Phase 5.0.
 *
 * V1 model: a single admin token pasted by the operator at login. The token
 * is persisted in `localStorage` so the user stays logged in across reloads.
 *
 * V2 will move to email + password + signed session token (Option B in
 * `.skills/security-auth/`).
 */
interface AuthState {
  token: string | null;
  setToken: (token: string) => void;
  clearToken: () => void;
}

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      setToken: (token) => set({ token }),
      clearToken: () => set({ token: null }),
    }),
    {
      name: "ai-leasing-os.auth",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
